import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

export default function TermsAndCondition() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <button onClick={handleClickOpen} className="terms-and-condition title">
        {t('footer.termsAndConditions')}
      </button>
      <Dialog
        className="common-dialog-style termsAndCondition-dialog"
        open={open}
        slotProps={{ paper: { className: 'paperClass' } }}
      >
        <DialogTitle className="header">
          {t('footer.termsAndConditions')}
          <IconButton aria-label="close" onClick={handleClose} className="closeIcon">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>{t('footer.termsAndConditions')}</DialogContent>
        <DialogActions className="dialogAction">
          <Button variant="contained">{t('button.ok')}</Button>
          <Button variant="contained" aria-label="close" onClick={handleClose}>
            {t('button.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
